import { Box, styled } from '@mui/material';
import { FocusTheme } from '@/components/Focus/configs/theme';

const FocusImageContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 16/9;
  overflow: hidden;
  border-radius: ${({ theme }) => `${theme.shape.borderRadius * 1.6}px`};
  background-color: ${({ theme }) => (theme as FocusTheme).customOverrides.Calendar.hover};
`;

export default FocusImageContainer;
